import { observer } from 'mobx-react';
import { useCallback, useEffect, useMemo } from 'react';
import { promobannerStore } from '../../store/promobannerStore';
import { PROMOBANNERR_TARGET } from '../../types/promobanners';
import PromobannerCategoryAndItem from '../PromobannerCategoryAndItem/PromobannerCategoryAndItem';
import { PromobannerLink } from '../PromobannerLink/PromobannerLink';
import { IPickerOption, PickerPosition } from 'src/view/components/Controls/Pickers/Picker/types';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';
import Text from '~/view/components/Text/Text';

export const PromobannerTarget = observer(() => {
  const options: IPickerOption[] = useMemo(
    () => [
      { label: localeStore.t('none'), value: PROMOBANNERR_TARGET.NONE },
      { label: localeStore.t('txt_category'), value: PROMOBANNERR_TARGET.CATEGORY },
      { label: localeStore.t('txt_item'), value: PROMOBANNERR_TARGET.ITEM },
      { label: localeStore.t('link_type'), value: PROMOBANNERR_TARGET.LINK },
    ],
    [localeStore.language]
  );

  const target: IPickerOption = useMemo(() => {
    return options.find((element) => element.value === promobannerStore.promobanner.target) || options[0];
  }, [promobannerStore.promobanner.target]);

  // If target is CATEGORY and select in modal ITEM, change target to ITEM
  useEffect(() => {
    if (promobannerStore.promobanner.target === PROMOBANNERR_TARGET.CATEGORY && promobannerStore.promobanner.product) {
      // @ts-ignore
      promobannerStore.changePromobanner({ target: options[2].value });
    }
  }, [promobannerStore.promobanner]);

  const selectTarget = useCallback((_options: IPickerOption[]) => {
    // Select target if option return not empty array
    // If select element re-returns empty array
    if (_options.length) promobannerStore.changePromobanner({ target: _options[0].value }, true);

    if (_options[0]?.value) {
      switch (_options[0]?.value) {
        // Clear product and link fields if target is CATEGORY
        case PROMOBANNERR_TARGET.CATEGORY: {
          promobannerStore.changePromobanner({ product: undefined, link: undefined });
          break;
        }
        // Clear category and product fields if target is LINK
        case PROMOBANNERR_TARGET.LINK: {
          promobannerStore.changePromobanner({ category: undefined, product: undefined });
          break;
        }
        // Clear all target fields if target is NONE
        case PROMOBANNERR_TARGET.NONE: {
          promobannerStore.changePromobanner({ product: undefined, link: undefined, category: undefined, target: undefined });
          break;
        }
      }
    }
  }, []);

  return (
    <div className="d-flex flex-row mt-6 flex-grow-1">
      <div className="d-flex flex-row flex-grow-1">
        <div className="promobanner-target mr-4">
          <Text type="block-header" text="link_type" />
          <Picker
            options={options}
            onSelect={selectTarget}
            selectedOptions={[target]}
            position={PickerPosition.PORTAL}
            hideResetIcon
            hideSelectedIcons
            numberVisibleOptionsInDropdown={4}
            className="full-width mt-2"
          />
        </div>

        {/* Show PromobannerLink if target LINK */}
        {target.value === PROMOBANNERR_TARGET.LINK ? <PromobannerLink /> : null}

        {/* Show PromobannerCategoryAndItem if target ITEM or CATEGORY */}
        {target.value === PROMOBANNERR_TARGET.ITEM || target.value === PROMOBANNERR_TARGET.CATEGORY ? <PromobannerCategoryAndItem /> : null}
      </div>
    </div>
  );
});
